import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Container, Row } from "react-bootstrap";
import TellUsMoreModal from "../Modal/TellUsMoreModal";
import { useQuery } from "@tanstack/react-query"; // React Query v5
import Select from "react-select";
import { getRequest } from "../services/apiMethods";
import LandingPageSearch from "../Componants/LandingPageSearch";
import { Link } from "react-router-dom";

const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "4px", // Adds padding inside the control box
    minHeight: "45px", // Ensure minimum height is applied
    width: "300px",
  }),
};
const validationSchema = Yup.object({
  services: Yup.string().required("This field is required."),
});

export default function LandingPage() {
  const [show, setShow] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState({
    service: "",
    category: "",
  });

  const handleClose = () => {
    setShow(false);
    setSelectedData({ service: "", category: "" }); // Reset selected data when closing the modal
  };
  // Fetch data from API
  const {
    data: categoryList,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getRequest(`/auth/view-category?search=${searchValue}`),
    enabled: !!searchValue,
  });

  useEffect(() => {
    localStorage.removeItem("userId");
  }, []);
  return (
    <Layout>
      <Container>
        <Row className="banner-landing align-items-center">
          <Col lg={6}>
            <div className="pre-registration">
              <div className="pre-registration-box">
                <h2>
                  Find a Professional
                  <br /> Electrician in your area
                </h2>
                <h3>Get free Quotes today</h3>
                {/* <p>
                  Tell us what your business specializes in and we’ll start
                  creating your account.
                </p> */}
                <div className="pre-registration-form new-form-setup-design">
                  <Formik
                    initialValues={{ services: "", category: "" }}
                    validationSchema={validationSchema} // Ensure vendorServices field is initialized
                    onSubmit={(values) => {
                      console.log("Form Submitted", values);
                      if (values.services) {
                        setShow(true);
                        setSelectedData({
                          service: values.services,
                          category: values.category,
                        });
                      }
                    }}
                  >
                    {({ setFieldValue, errors, touched, values }) => (
                      <Form>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 10,
                            marginTop: "2px",
                          }}
                        >
                          <div>
                            <div>
                              <LandingPageSearch
                                setSearchValue={setSearchValue}
                                searchValue={searchValue}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                setFieldValue={setFieldValue}
                                errors={errors}
                                touched={touched}
                              />
                              {searchValue && !values?.services && (
                                <ul
                                  className="search-list"
                                  style={{
                                    listStyle: "none",
                                    padding: 0,
                                    margin: 0,
                                    position: "absolute",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 999,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  {categoryList?.data?.map((ele, index) => {
                                    return (
                                      <>
                                        <li
                                          key={index}
                                          onClick={() => {
                                            setSearchText(ele?.serviceName);
                                            setFieldValue(
                                              "services",
                                              ele?.serviceId
                                            ); // Clear field value
                                            setFieldValue(
                                              "category",
                                              ele?.categoryId
                                            ); // Clear grouped services
                                          }}
                                          style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {ele?.serviceName}
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              )}
                              {errors.services && touched.services && (
                                <div className="error-message">
                                  {errors.services}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <button type="submit">Get Started</button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="landing-banner">
              <div className="landing-head text-center">
                <p>
                  "Only SparkPro electricians who are fully verified and background checked earn the blue tick - trusted by homeowners and businesses across the UK."
                </p>
              </div>
            </div>
            <div className="landing-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 27 27"
                fill="none"
              >
                <rect
                  width="25"
                  height="25"
                  rx="12.5"
                  transform="matrix(-1 0 0 1 26 1)"
                  fill="#337FE0"

                />
                <path
                  d="M20.0001 10L11.7066 16.8581L8 13.2486"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </Col>
        </Row>
        <div className="popular-services-contain">
          <Row>
            <Col lg={12}>
              <h2>Popular Services</h2>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/rewires.jpg")} />
                <h3>Rewires</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/three-phase.jpeg")} />
                <h3>3 Phase Electrics</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/charging.jpeg")} />
                <h3>EV Charger Installations</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/outdoor.jpeg")} />
                <h3>Outdoor Lighting</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/dental-surgery.png")} />
                <h3>Additional Power & Lighting</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img src={require("../assets/images/emergency-img.png")} />
                <h3>Emergency Call Outs</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img
                  src={require("../assets/images/fire-security-alarms.jpg")}
                />
                <h3>Fire & Security Alarms</h3>
                <p></p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="popular-services-card">
                <img
                  src={require("../assets/images/equipment-installation.jpeg")}
                />
                <h3>Renewable Energy installations</h3>
                <p></p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <TellUsMoreModal
        show={show}
        handleClose={handleClose}
        selectedData={selectedData}
      />

      <section className="lgoout-footer-sec">
        <Container>
          <div className="lgoout-footer-box">
            <div className="spark-footer-logo">
              <img
                src={require("../assets/images/SparkPro-logo.svg").default}
              />
            </div>
            <div>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/customer-faqs">Customer FAQs</Link>
                </li>
                <li>
                  <Link to="/vendor-faqs">Vendor FAQs</Link>
                </li>
              </ul>
            </div>
            <div className="address-secton ">
              <Row className="justify-content-between ">
                <Col md={12} xs={6} className="address-section">
                  <span>Address</span>
                  {/* <p>
                SparkPro LTD, 85 First Floor Great Portland Street London W1W
                7LT
              </p> */}

                  <p class="address">
                    SparkPro LTD
                    <br />
                    85 First Floor
                    <br />
                    Great Portland Street
                    <br />
                    London W1W 7LT
                  </p>
                </Col>
                <Col md={12} xs={6} className="trust-logo">
                  <div className="trustpilot-logo">

                    <svg xmlns="http://www.w3.org/2000/svg" width="119" height="30" viewBox="0 0 119 30" fill="none">
                      <path d="M14.3574 0.414307L17.5808 10.335H28.0121L19.573 16.4664L22.7965 26.3871L14.3574 20.2557L5.91833 26.3871L9.14177 16.4664L0.702702 10.335H11.134L14.3574 0.414307Z" fill="#05B577" />
                      <path d="M43.058 11.3063H37.913V24.5363H36.023V11.3063H30.878V9.62625H43.058V11.3063ZM48.4293 15.1913C47.5053 15.2053 46.6863 15.4433 45.9723 15.9053C45.2723 16.3533 44.7753 16.9763 44.4813 17.7743V24.5363H42.6333V13.5743H44.3553V16.1153C44.7333 15.3593 45.2303 14.7503 45.8463 14.2883C46.4763 13.8123 47.1343 13.5463 47.8203 13.4903C47.9603 13.4903 48.0793 13.4903 48.1773 13.4903C48.2753 13.4903 48.3593 13.4973 48.4293 13.5113V15.1913ZM49.5811 20.1473V13.5743H51.4291V19.7903C51.4291 20.9103 51.6251 21.7503 52.0171 22.3103C52.4091 22.8703 52.9901 23.1503 53.7601 23.1503C54.2641 23.1503 54.7471 23.0453 55.2091 22.8353C55.6851 22.6113 56.1121 22.2963 56.4901 21.8903C56.8681 21.4843 57.1621 21.0013 57.3721 20.4413V13.5743H59.2201V22.4363C59.2201 22.6603 59.2621 22.8283 59.3461 22.9403C59.4441 23.0383 59.5981 23.0943 59.8081 23.1083V24.5363C59.5981 24.5643 59.4301 24.5783 59.3041 24.5783C59.1921 24.5923 59.0801 24.5993 58.9681 24.5993C58.6181 24.5993 58.3171 24.4943 58.0651 24.2843C57.8131 24.0603 57.6801 23.7873 57.6661 23.4653L57.6241 22.1843C57.1481 22.9963 56.5041 23.6263 55.6921 24.0743C54.8941 24.5223 54.0191 24.7463 53.0671 24.7463C51.9191 24.7463 51.0511 24.3613 50.4631 23.5913C49.8751 22.8073 49.5811 21.6593 49.5811 20.1473ZM65.4814 24.7463C64.5714 24.7463 63.7174 24.5993 62.9194 24.3053C62.1214 23.9973 61.4354 23.5423 60.8614 22.9403L61.5754 21.6383C62.2054 22.2263 62.8354 22.6463 63.4654 22.8983C64.0954 23.1503 64.7394 23.2763 65.3974 23.2763C66.1534 23.2763 66.7694 23.1363 67.2454 22.8563C67.7214 22.5623 67.9594 22.1353 67.9594 21.5753C67.9594 21.1693 67.8334 20.8683 67.5814 20.6723C67.3434 20.4763 67.0004 20.3153 66.5524 20.1893C66.1044 20.0493 65.5724 19.8953 64.9564 19.7273C64.2004 19.5033 63.5634 19.2653 63.0454 19.0133C62.5274 18.7613 62.1354 18.4463 61.8694 18.0683C61.6034 17.6903 61.4704 17.2143 61.4704 16.6403C61.4704 15.9403 61.6524 15.3523 62.0164 14.8763C62.3804 14.3863 62.8774 14.0153 63.5074 13.7633C64.1514 13.5113 64.8794 13.3853 65.6914 13.3853C66.5034 13.3853 67.2384 13.5113 67.8964 13.7633C68.5544 14.0153 69.1214 14.3863 69.5974 14.8763L68.7574 16.1573C68.3234 15.7093 67.8474 15.3803 67.3294 15.1703C66.8114 14.9463 66.2304 14.8343 65.5864 14.8343C65.2084 14.8343 64.8374 14.8833 64.4734 14.9813C64.1094 15.0653 63.8084 15.2263 63.5704 15.4643C63.3324 15.6883 63.2134 16.0103 63.2134 16.4303C63.2134 16.7803 63.3044 17.0603 63.4864 17.2703C63.6824 17.4663 63.9624 17.6343 64.3264 17.7743C64.7044 17.9143 65.1594 18.0683 65.6914 18.2363C66.5174 18.4743 67.2314 18.7123 67.8334 18.9503C68.4494 19.1883 68.9254 19.4963 69.2614 19.8743C69.5974 20.2523 69.7654 20.7773 69.7654 21.4493C69.7654 22.4853 69.3734 23.2973 68.5894 23.8853C67.8054 24.4593 66.7694 24.7463 65.4814 24.7463ZM77.0703 23.9903C76.9163 24.0603 76.7063 24.1513 76.4403 24.2633C76.1743 24.3753 75.8663 24.4733 75.5163 24.5573C75.1663 24.6413 74.7953 24.6833 74.4033 24.6833C73.9553 24.6833 73.5423 24.6063 73.1643 24.4523C72.7863 24.2843 72.4853 24.0323 72.2613 23.6963C72.0373 23.3463 71.9253 22.9123 71.9253 22.3943V15.0233H70.4343V13.5743H71.9253V9.92025H73.7733V13.5743H76.2303V15.0233H73.7733V21.8273C73.8013 22.2193 73.9343 22.5133 74.1723 22.7093C74.4103 22.8913 74.6903 22.9823 75.0123 22.9823C75.3763 22.9823 75.7123 22.9193 76.0203 22.7933C76.3283 22.6673 76.5313 22.5763 76.6293 22.5203L77.0703 23.9903ZM84.1081 24.7463C83.2121 24.7463 82.4141 24.5223 81.7141 24.0743C81.0141 23.6263 80.4611 23.0593 80.0551 22.3733V29.0093H78.2071V13.5743H79.8451V15.6323C80.2791 14.9603 80.8461 14.4213 81.5461 14.0153C82.2461 13.5953 83.0091 13.3853 83.8351 13.3853C84.5911 13.3853 85.2841 13.5393 85.9141 13.8473C86.5441 14.1553 87.0901 14.5753 87.5521 15.1073C88.0141 15.6393 88.3711 16.2483 88.6231 16.9343C88.8891 17.6063 89.0221 18.3133 89.0221 19.0553C89.0221 20.0913 88.8121 21.0433 88.3921 21.9113C87.9861 22.7793 87.4121 23.4723 86.6701 23.9903C85.9281 24.4943 85.0741 24.7463 84.1081 24.7463ZM83.5411 23.1503C84.0871 23.1503 84.5771 23.0383 85.0111 22.8143C85.4591 22.5763 85.8371 22.2683 86.1451 21.8903C86.4671 21.4983 86.7121 21.0573 86.8801 20.5673C87.0481 20.0773 87.1321 19.5733 87.1321 19.0553C87.1321 18.5093 87.0341 17.9913 86.8381 17.5013C86.6561 17.0113 86.3901 16.5773 86.0401 16.1993C85.7041 15.8213 85.3051 15.5273 84.8431 15.3173C84.3951 15.0933 83.9051 14.9813 83.3731 14.9813C83.0371 14.9813 82.6871 15.0443 82.3231 15.1703C81.9731 15.2963 81.6371 15.4783 81.3151 15.7163C80.9931 15.9403 80.7201 16.1993 80.4961 16.4933C80.2721 16.7873 80.1251 17.1023 80.0551 17.4383V20.5673C80.2651 21.0433 80.5451 21.4773 80.8951 21.8693C81.2451 22.2613 81.6511 22.5763 82.1131 22.8143C82.5751 23.0383 83.0511 23.1503 83.5411 23.1503ZM90.7151 24.5363V13.5743H92.5631V24.5363H90.7151ZM90.7151 11.5163V9.20625H92.5631V11.5163H90.7151ZM95.0209 9.20625H96.8689V21.7013C96.8689 22.3033 96.9529 22.6743 97.1209 22.8143C97.2889 22.9543 97.4919 23.0243 97.7299 23.0243C98.0239 23.0243 98.3039 22.9963 98.5699 22.9403C98.8359 22.8703 99.0599 22.8003 99.2419 22.7303L99.5359 24.2423C99.2279 24.3683 98.8639 24.4733 98.4439 24.5573C98.0239 24.6413 97.6529 24.6833 97.3309 24.6833C96.6169 24.6833 96.0499 24.4803 95.6299 24.0743C95.2239 23.6683 95.0209 23.1013 95.0209 22.3733V9.20625ZM105.2 24.7463C104.374 24.7463 103.625 24.5993 102.953 24.3053C102.281 23.9973 101.7 23.5843 101.21 23.0663C100.72 22.5343 100.342 21.9253 100.076 21.2393C99.8097 20.5533 99.6767 19.8323 99.6767 19.0763C99.6767 18.3063 99.8097 17.5783 100.076 16.8923C100.342 16.2063 100.72 15.6043 101.21 15.0863C101.7 14.5543 102.281 14.1413 102.953 13.8473C103.639 13.5393 104.395 13.3853 105.221 13.3853C106.033 13.3853 106.775 13.5393 107.447 13.8473C108.119 14.1413 108.7 14.5543 109.19 15.0863C109.694 15.6043 110.079 16.2063 110.345 16.8923C110.611 17.5783 110.744 18.3063 110.744 19.0763C110.744 19.8323 110.611 20.5533 110.345 21.2393C110.079 21.9253 109.701 22.5343 109.211 23.0663C108.721 23.5843 108.133 23.9973 107.447 24.3053C106.775 24.5993 106.026 24.7463 105.2 24.7463ZM101.567 19.0973C101.567 19.8533 101.728 20.5393 102.05 21.1553C102.386 21.7713 102.827 22.2613 103.373 22.6253C103.919 22.9753 104.528 23.1503 105.2 23.1503C105.872 23.1503 106.481 22.9683 107.027 22.6043C107.587 22.2403 108.028 21.7503 108.35 21.1343C108.686 20.5043 108.854 19.8113 108.854 19.0553C108.854 18.2993 108.686 17.6133 108.35 16.9973C108.028 16.3813 107.587 15.8913 107.027 15.5273C106.481 15.1633 105.872 14.9813 105.2 14.9813C104.528 14.9813 103.919 15.1703 103.373 15.5483C102.827 15.9123 102.386 16.4023 102.05 17.0183C101.728 17.6343 101.567 18.3273 101.567 19.0973ZM117.913 23.9903C117.759 24.0603 117.549 24.1513 117.283 24.2633C117.017 24.3753 116.709 24.4733 116.359 24.5573C116.009 24.6413 115.638 24.6833 115.246 24.6833C114.798 24.6833 114.385 24.6063 114.007 24.4523C113.629 24.2843 113.328 24.0323 113.104 23.6963C112.88 23.3463 112.768 22.9123 112.768 22.3943V15.0233H111.277V13.5743H112.768V9.92025H114.616V13.5743H117.073V15.0233H114.616V21.8273C114.644 22.2193 114.777 22.5133 115.015 22.7093C115.253 22.8913 115.533 22.9823 115.855 22.9823C116.219 22.9823 116.555 22.9193 116.863 22.7933C117.171 22.6673 117.374 22.5763 117.472 22.5203L117.913 23.9903Z" fill="white" />
                    </svg>

                    <div className="svg2" >
                      <svg xmlns="http://www.w3.org/2000/svg" width="124" height="24" viewBox="0 0 124 24" fill="none">
                        <rect width="24" height="24" fill="#05B577" />
                        <path d="M12 4L13.7961 9.52786H19.6085L14.9062 12.9443L16.7023 18.4721L12 15.0557L7.29772 18.4721L9.09383 12.9443L4.39155 9.52786H10.2039L12 4Z" fill="white" />
                        <rect width="24" height="24" transform="translate(25)" fill="#05B577" />
                        <path d="M37 4L38.7961 9.52786H44.6085L39.9062 12.9443L41.7023 18.4721L37 15.0557L32.2977 18.4721L34.0938 12.9443L29.3915 9.52786H35.2039L37 4Z" fill="white" />
                        <rect width="24" height="24" transform="translate(50)" fill="#05B577" />
                        <path d="M62 4L63.7961 9.52786H69.6085L64.9062 12.9443L66.7023 18.4721L62 15.0557L57.2977 18.4721L59.0938 12.9443L54.3915 9.52786H60.2039L62 4Z" fill="white" />
                        <rect width="24" height="24" transform="translate(75)" fill="#05B577" />
                        <path d="M87 4L88.7961 9.52786H94.6085L89.9062 12.9443L91.7023 18.4721L87 15.0557L82.2977 18.4721L84.0938 12.9443L79.3915 9.52786H85.2039L87 4Z" fill="white" />
                        <rect width="24" height="24" transform="translate(100)" fill="#DCDCE6" />
                        <rect x="100" width="12" height="24" fill="#05B577" />
                        <path d="M112 4L113.796 9.52786H119.608L114.906 12.9443L116.702 18.4721L112 15.0557L107.298 18.4721L109.094 12.9443L104.392 9.52786H110.204L112 4Z" fill="white" />
                      </svg>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
        <div className="copyright-txt">
          <p>© 2025 SparkPro. All rights reserved.</p>
        </div>
      </section>
    </Layout>
  );
}





// import React from "react";
// import { Container, Row, Col, Button, Image } from "react-bootstrap";
 
// const LandingPage = () => {
//   const containerStyle = {
//     minHeight: "100vh",
//     background: "linear-gradient(180deg, #337fe1 16%, #296abe 32%, #0f386e 91%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     padding: "20px",
//   };
 
//   const imageStyle = {
//     width: "160px",
//     height: "160px",
//     objectFit: "cover",
//     borderRadius: "50%",
//     marginBottom: "2rem",
//   };
 
//   const headingStyle = {
//     fontSize: "2.5rem",
//     fontWeight: "bold",
//     marginBottom: "1rem",
//   };
 
//   const paragraphStyle = {
//     fontSize: "1.125rem",
//     marginBottom: "2rem",
//     maxWidth: "600px",
//   };
 
//   const buttonGroupStyle = {
//     display: "flex",
//     gap: "1rem",
//     justifyContent: "center",
//   };
 
//   return (
//     <div className="logo-content" style={containerStyle}>
//       <img src={require("../assets/images/SparkPro-logo.svg").default} />
//       <h1 style={headingStyle}>Coming Soon</h1>
//       <p style={paragraphStyle}>
//         We're working hard to bring you something awesome. Stay tuned!
//       </p>
//     </div>
//   );
// };
 
// export default LandingPage;
 